import { useState, useEffect } from "react";
import { router } from "expo-router";
import { onFreeTierLimitExceeded, onFreeTierStatus, FreeTierLimits } from "../utils/freeTierUtils";
import i18n from "../locales/i18n";

export const useFreeTierModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [limits, setLimits] = useState<FreeTierLimits | null>(null);

  useEffect(() => {
    const handleFreeTierLimitExceeded = (data: { limits: FreeTierLimits | null }) => {
      setLimits(data.limits);
      setIsVisible(true);
    };

    const handleFreeTierStatus = (data: { 
      withinLimits: boolean; 
      isPaidPlan: boolean; 
      limits: FreeTierLimits | null 
    }) => {
      // Optional: You can use this for analytics or to show different UI states
    };

    // Subscribe to free tier events
    const limitExceededSubscription = onFreeTierLimitExceeded(handleFreeTierLimitExceeded);
    const statusSubscription = onFreeTierStatus(handleFreeTierStatus);

    // Cleanup listeners on unmount
    return () => {
      limitExceededSubscription.remove();
      statusSubscription.remove();
    };
  }, []);

  const hideModal = () => {
    setIsVisible(false);
    setLimits(null);
  };

  const handleUpgrade = () => {
    // Navigate to contact page for upgrade assistance
    hideModal();
    router.push("/(drawer)/params/contact");
  };

  return {
    isVisible,
    limits,
    hideModal,
    handleUpgrade,
  };
};